
import { ENTITY_TYPES } from '@sales-center/common'


export function mapEntityTypeToEnum(entityType: string): ENTITY_TYPES {
  if (entityType === 'Lead') {
    return ENTITY_TYPES.Lead
  } else if (entityType === 'Opportunity') {
    return ENTITY_TYPES.Opportunity
  } else {
    return ENTITY_TYPES.DraftLead
  }
}
